import customAxios from "./axiosConfig";

const ImportDataService = {
    upload: function (data) {
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        var api_url = window.Urls['temporaryfile-list']();
        const getFormData = object => Object.keys(object).reduce((formData, key) => {
            if (Array.isArray(object[key])) {
                formData.append(key, JSON.stringify(object[key]));
            } else {
                formData.append(key, object[key]);
            }
            return formData;
        }, new FormData());
        return customAxios.post(api_url, getFormData(data), config);
    },
    importFile: function (id, data) {
        var api_url = window.Urls['temporaryfile-import-file'](id);
        return customAxios.post(api_url, data).then(function (response) {
            if (response.data.type == 'cost') {
                window.mixpanel.track('Costs: import finished', {});
            } else {
                window.mixpanel.track('Customers: import finished', {});
            }
            return response;
        });
    },
};
export default ImportDataService;